import { useContext, useEffect, useRef, useState } from 'react';
import { useOnClickOutside } from '@alf/uikit';
import { LOG_ACTIONS, logNewRelicAction } from '@namespace/analytics';
import { useOtherSettings } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';
import { SnippetsContext } from '@namespace/snippets';
import { MODE } from '../../../constants';
import { MarketDescriptionTooltip } from '../MarketDescriptionTooltip';
import { MarketDescriptionTrigger } from '../MarketDescriptionTrigger';

export const useMarketDescription = (marketTemplateId, serviceId) => {
  const { language } = useI18n();
  const { isShowMarketDescriptions } = useOtherSettings();
  const [{ snippets }, actions] = useContext(SnippetsContext);
  const [isOpen, setIsOpen] = useState(false);
  const tooltipRef = useRef();
  const triggerRef = useRef();
  const snippetId = `market_description_${marketTemplateId}`;
  const snippet = snippets?.[snippetId]?.[language];

  const isEnabled =
    isShowMarketDescriptions &&
    marketTemplateId != null &&
    snippet &&
    serviceId === MODE.PRE_MATCH;

  const closeTooltip = (e) => {
    e.stopPropagation();
    setIsOpen(false);
  };
  const outsideClickHandler = isEnabled ? closeTooltip : null;

  useOnClickOutside(outsideClickHandler, tooltipRef, triggerRef);

  useEffect(() => {
    if (!snippet && marketTemplateId != null) {
      actions.GET_SNIPPET(snippetId);
    }
  }, [actions, marketTemplateId, snippet, snippetId]);

  if (!isEnabled) {
    return {};
  }

  const toggleTooltip = (e) => {
    e.stopPropagation();

    if (!isOpen) {
      logNewRelicAction(LOG_ACTIONS.SPORTS_BOOK_MARKET_DESCRIPTION_OPEN, {
        marketTemplateId
      });
    }

    setIsOpen(!isOpen);
  };

  const descrTrigger = (
    <MarketDescriptionTrigger
      ref={triggerRef}
      isOpen={isOpen}
      onClick={toggleTooltip}
    />
  );

  const descrTooltip = isOpen && (
    <MarketDescriptionTooltip
      ref={tooltipRef}
      marketTemplateId={marketTemplateId}
    />
  );

  return { descrTrigger, descrTooltip };
};
